import { InjectionToken } from '@angular/core';

export interface ConfirmClickConfig {
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  confirmColor: 'primary' | 'accent' | 'warn';
}

export const CONFIRM_CLICK_CONFIG = new InjectionToken<ConfirmClickConfig>(
  'CONFIRM_CLICK_CONFIG',
  {
    factory: () => ({
      title: 'Confirmar acción',
      message: '¿Está seguro que desea continuar?',
      confirmText: 'Confirmar',
      cancelText: 'Cancelar',
      confirmColor: 'warn',
    }),
  }
);
